import {SyncState} from '@docma-mm-core/model/sync-state/sync-state';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {LoadState} from '@docma-mm-core/model/load-state/load-state';
import {ActivityData} from '@docma-mm-core/activity/activity';
import {AttachmentData} from '@docma-mm-core/attachment/attachment';
import {User} from '@docma-mm-core/user/user';
import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {GroupData} from '@docma-mm-core/group/group';

export class SyncResult {
  constructor(init?: Partial<SyncResult>) {
    if (init)  {
      Object.assign(this, init);
    }
  }

  syncState: SyncState;

  faultLoadStates: LoadState<FaultData>[] = [];
  attachmentsLoadStates: LoadState<AttachmentData>[] = [];
  attachmentScribblesLoadStates: LoadState<ScribbleData>[] = [];
  groupLoadStates: LoadState<GroupData>[] = [];
  activityLoadStates: LoadState<ActivityData>[] = [];
  activityAttachmentsLoadStates: LoadState<AttachmentData>[] = [];
  activityAttachmentScribblesLoadStates: LoadState<ScribbleData>[] = [];
  modifiedOn?: Date;
  modifier?: User;
}
